/** @typedef {new (...args: any[]) => any} Constructor */

/**
 * @template {!Constructor} T
 * @param {T} superClass - The class to extend
 */
export const MutationObserverMixin = superClass => class MutationObserverMix extends superClass {

	/**
	 * @type {MutationObserver}
	 */
	_mutationObserver;

	/**
	 * @type {MutationObserverInit}
	 */
	mutationObserverOptions;

	constructor () {
		super();

		this._mutationObserver = new MutationObserver(this._mutationCallback.bind(this));
	}

	connectedCallback () {
		super.connectedCallback();

		this._mutationObserver.observe(this, this.mutationObserverOptions);
	}

	disconnectedCallback () {
		this._mutationObserver.disconnect();

		super.disconnectedCallback();
	}

	/**
	 * @type {MutationCallback}
	 */
	_mutationCallback (mutationList) {
		for (const mutation of mutationList) {
			this.handleMutation(mutation);
		}
	}

	handleMutation () {
		throw new Error('Not implemented.');
	}
};
